export const TITLE = 'BMW Group'
